import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

type AppStatus = 'pending' | 'approved' | 'rejected' | null;

interface ApplicationStatusState {
  creatorApplied: boolean;
  creatorStatus: AppStatus;
  managerApplied: boolean;
  managerStatus: AppStatus;
  checked: boolean; // true once fetched at least once
}

const initialState: ApplicationStatusState = {
  creatorApplied: false,
  creatorStatus: null,
  managerApplied: false,
  managerStatus: null,
  checked: false,
};

export const fetchApplicationStatus = createAsyncThunk(
  'applicationStatus/fetch',
  async () => {
    const response = await api.get('/application-status/me');
    return {
      creatorApplied: !!response.data.creator_applied,
      creatorStatus: (response.data.creator_status ?? null) as AppStatus,
      managerApplied: !!response.data.manager_applied,
      managerStatus: (response.data.manager_status ?? null) as AppStatus,
    };
  }
);

const applicationStatusSlice = createSlice({
  name: 'applicationStatus',
  initialState,
  reducers: {
    resetApplicationStatus: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchApplicationStatus.fulfilled, (state, action) => {
      state.creatorApplied = action.payload.creatorApplied;
      state.creatorStatus = action.payload.creatorStatus;
      state.managerApplied = action.payload.managerApplied;
      state.managerStatus = action.payload.managerStatus;
      state.checked = true;
    });
  },
});

export const { resetApplicationStatus } = applicationStatusSlice.actions;
export default applicationStatusSlice.reducer;
